var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKosherHalalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.531,
    height: 73.187,
    viewBox: "0 0 72.531 73.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2224.5 -2139.844)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: 8.278,
    x2: 8.278,
    transform: "translate(2270.699 2165.177)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250,2286.571a13.452,13.452,0,0,0,13.46,13.46",
    transform: "translate(-17.954 -108.15)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2226,2178.421c0-16.141,19.65-36.421,19.65-36.421s19.65,20.28,19.65,36.421a19.651,19.651,0,1,1-39.3,0Z",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2361.177,2204.5a105.087,105.087,0,0,1,8.328-9.933s19.866,20.28,19.866,36.421a19.869,19.869,0,0,1-37.93,8.281",
    transform: "translate(-93.839 -39.327)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 13.244,
    x2: 13.244,
    transform: "translate(2277.321 2193.321)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 20.694,
    x2: 20.694,
    transform: "translate(2269.043 2184.215)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 22.349,
    x2: 22.349,
    transform: "translate(2264.077 2177.594)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y1: 11.589,
    x2: 11.589,
    transform: "translate(2270.699 2171.799)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosherHalalIcon);
export default __webpack_public_path__ + "static/media/kosher-halal-icon.02c05787.svg";
export { ForwardRef as ReactComponent };